var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"qrTag"}},[_c('vue-qr',{ref:"qrTag",staticClass:"qrTag",attrs:{"size":500,"text":_vm.qrValue}}),_c('b-icon-printer',{staticClass:"d-block cursor-pointer h5 mt-2",on:{"click":function($event){return _vm.printImage()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }